import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Helpers } from "../../../helpers/Helpers";
import toast from "react-hot-toast";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import { RootState } from "../../../redux/store";
import { CountryService } from "../../../services/CountryService";
import { GetCountryByIdResponse } from "../../../models/response/country/GetCountryByIdResponse";
import CustomSwitch from "../../../components/CustomSwitch";
import { AddCountryResponse } from "../../../models/response/country/AddCountryResponse";
import CustomNumberInput from "../../../components/CustomNumberInput";

const CountryAdd = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > Ülke Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const [countryId, setCountryId] = useState<string | undefined>(undefined);
    const [shortName, setShortName] = useState('');
    const [longName, setLongName] = useState('');
    const [isEurope, setIsEurope] = useState(false);
    const [enName, setEnName] = useState<string | undefined>(undefined);
    const [isO2, setIsO2] = useState<string | undefined>(undefined);
    const [isO3, setIsO3] = useState<string | undefined>(undefined);
    const [isO_Numeric, setIsO_Numeric] = useState<string | undefined>(undefined);
    const [mid, setMid] = useState<string | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                dispatch(storeActivityIndicator(true))

                var response: GetCountryByIdResponse = await CountryService.getCountryById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setCountryId(response.data.countryId);
                setShortName(response.data.code);
                setLongName(response.data.name);
                setEnName(response.data.enName);
                setIsO2(response.data.isO2);
                setIsO3(response.data.isO3);
                setIsO_Numeric(response.data.isO_Numeric);
                setMid(response.data.mid);
                setIsEurope(response.data.isEurope);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveCountry = async () => {
        try {
            if (Helpers.isEmpty(shortName))
                toast.error('Kodu alanını doldurunuz!')
            else if (Helpers.isEmpty(longName))
                toast.error('Adı alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddCountryResponse = await CountryService.addCountry({
                    countryId: countryId,
                    name: longName,
                    code: shortName,
                    isEurope: isEurope ? 1 : 0,
                    enName: enName,
                    isO2: isO2,
                    isO3: isO3,
                    isO_Numeric: isO_Numeric,
                    mid: mid
                });

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <KTCard className="ebbe-card">
                        <KTCardBody>
                            <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                            <div className='row'>
                                <div className="col-md-4">
                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Kodu</label>
                                    <input style={{ border: '1px solid #F1F1F4' }} value={shortName} onChange={(e) => setShortName(e.target.value)} type="text" className="form-control form-control-solid" />
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Adı</label>
                                    <input style={{ border: '1px solid #F1F1F4' }} value={longName} onChange={(e) => setLongName(e.target.value)} type="text" className="form-control form-control-solid" />
                                </div>

                                <div className="col-md-4">
                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Adı (EN)</label>
                                    <input style={{ border: '1px solid #F1F1F4' }} value={enName} onChange={(e) => setEnName(e.target.value)} type="text" className="form-control form-control-solid" />
                                </div>
                            </div>

                            <div className='row mt-5'>
                                <div className="col-md-4">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">ISO-2 Kod</label>
                                    <input style={{ border: '1px solid #F1F1F4' }} value={isO2} onChange={(e) => setIsO2(e.target.value)} type="text" className="form-control form-control-solid" />
                                </div>

                                <div className="col-md-4">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">ISO-3 Kod</label>
                                    <input style={{ border: '1px solid #F1F1F4' }} value={isO3} onChange={(e) => setIsO3(e.target.value)} type="text" className="form-control form-control-solid" />
                                </div>

                                <div className="col-md-4">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">ISO Nümerik</label>
                                    <CustomNumberInput value={isO_Numeric} setValue={setIsO_Numeric} />
                                </div>
                            </div>

                            <div className='row mt-5'>
                                <div className="col-md-4">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">MID</label>
                                    <input style={{ border: '1px solid #F1F1F4' }} value={mid} onChange={(e) => setMid(e.target.value)} type="text" className="form-control form-control-solid" />
                                </div>

                                <div className="col-md-4">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">AB Ülkesi</label>

                                    <CustomSwitch isActive={isEurope} setIsActive={setIsEurope} />
                                </div>
                            </div>
                        </KTCardBody>
                    </KTCard>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveCountry}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default CountryAdd;